import { Component, AfterViewInit, Input, HostListener, ElementRef, ViewChild, ChangeDetectorRef, OnInit } from '@angular/core';

@Component({
  selector: 'plr-marquee-text-box',
  templateUrl: './marquee-text-box.component.html',
  styleUrls: ['./marquee-text-box.component.scss']
})
export class MarqueeTextBoxComponent implements OnInit, AfterViewInit {
  shouldMarquee = false;

  @ViewChild('marqueeText')
  textContainer: ElementRef;

  constructor(private element: ElementRef,
    private changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit() {
    this.checkMarquee();
  }

  ngAfterViewInit() {
    this.checkMarquee();
  }

  @HostListener('window:resize', ['$event.target'])
  onResize()
  {
    this.checkMarquee();
  }

  checkMarquee() {
    if(this.textContainer){
      this.shouldMarquee = this.element.nativeElement.offsetWidth < this.textContainer.nativeElement.offsetWidth;
      this.changeDetectorRef.detectChanges();
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/pillar/common/components/marquee-text-box.component.ts